// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2SpRP","header":"ClearentDisclaimer_header__3jhvH","inner":"ClearentDisclaimer_inner__1sSm1"};